/** Reveal only when needed, including inside a merchant's scrollable embed.
 * Native scrolling handles every scroll ancestor; no host-page coordinates or
 * global scroll reset are needed. Focus and content arrive together. */
export function focusClaimHeading(heading: HTMLElement | null, reveal = true) {
  if (!heading) return;
  heading.focus({ preventScroll: true });
  if (!reveal) return;
  const view = heading.ownerDocument.defaultView;
  if (!view) return;
  const rect = heading.getBoundingClientRect();
  const margin = Number.parseFloat(view.getComputedStyle(heading).scrollMarginTop) || 16;
  let top = margin;
  let bottom = view.innerHeight;
  for (let ancestor = heading.parentElement; ancestor; ancestor = ancestor.parentElement) {
    if (/(auto|scroll|hidden|clip)/.test(view.getComputedStyle(ancestor).overflowY)) {
      const bounds = ancestor.getBoundingClientRect();
      top = Math.max(top, bounds.top + margin);
      bottom = Math.min(bottom, bounds.bottom);
    }
  }
  const progress = heading.closest('.cw-step')?.parentElement?.querySelector<HTMLElement>('.cw-progress');
  // Include orientation when it fits; a short embedded viewport still gives
  // the active heading priority over the rail.
  const context = progress ?? heading.closest<HTMLElement>('.claim-heading');
  const target = context && rect.bottom - context.getBoundingClientRect().top < bottom - top ? context : heading;
  if (target.getBoundingClientRect().top < top || rect.bottom > bottom) {
    target.scrollIntoView?.({ block: 'start', inline: 'nearest', behavior: 'instant' });
  }
}
